import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import Apply from "@/pages/Apply";
import MemberPortal from "@/pages/MemberPortal";
import AdminPortal from "@/pages/AdminPortal";
import ESign from "@/pages/ESign";
import PaymentReturn from "@/pages/PaymentReturn";
import AuthCallback from "@/pages/AuthCallback";
import Listings from "@/pages/Listings";
import NewListing from "@/pages/NewListing";
import EditListing from "@/pages/EditListing";
import Contact from "@/pages/Contact";
import Accounting from "@/pages/Accounting";
import AdsLanding from "@/pages/AdsLanding";
import StopForeclosureFast from "@/pages/StopForeclosureFast";
import MortgageReliefNoBankruptcy from "@/pages/MortgageReliefNoBankruptcy";
import SheriffSaleHelp from "@/pages/SheriffSaleHelp";
import StateForeclosureLanding from "@/pages/StateForeclosureLanding";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import usePageTracking from "@/lib/usePageTracking";

function AppRouter() {
  const location = useLocation();
  usePageTracking();
  // CRITICAL: Detect Emergent OAuth callback BEFORE rendering normal routes.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/accounting" element={<Accounting />} />
      <Route path="/ads" element={<AdsLanding />} />
      <Route path="/relief" element={<AdsLanding />} />
      <Route path="/stop-foreclosure-fast" element={<StopForeclosureFast />} />
      <Route path="/mortgage-relief-without-bankruptcy" element={<MortgageReliefNoBankruptcy />} />
      <Route path="/sheriff-sale-help" element={<SheriffSaleHelp />} />
      <Route path="/stop-foreclosure-in/:state" element={<StateForeclosureLanding />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/listings" element={<Listings />} />
      <Route path="/payment-success" element={<PaymentReturn />} />
      <Route
        path="/apply"
        element={<ProtectedRoute><Apply /></ProtectedRoute>}
      />
      <Route
        path="/esign/:formType"
        element={<ProtectedRoute><ESign /></ProtectedRoute>}
      />
      <Route
        path="/portal"
        element={<ProtectedRoute><MemberPortal /></ProtectedRoute>}
      />
      <Route
        path="/listings/new"
        element={<ProtectedRoute><NewListing /></ProtectedRoute>}
      />
      <Route
        path="/listings/:id/edit"
        element={<ProtectedRoute><EditListing /></ProtectedRoute>}
      />
      <Route
        path="/admin"
        element={<ProtectedRoute adminOnly><AdminPortal /></ProtectedRoute>}
      />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App bg-paper">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
